export function SearchInput(textInput, clearButton, thresholdMillis, onTextChange) {
    this.textInput = textInput;
    this.clearButton = clearButton;

    const self = this;
    let timeoutHandle = -1;

    this.textInput.addEventListener('input', function (evt) {
        clearTimeout(timeoutHandle);

        timeoutHandle = setTimeout(function () {
            onTextChange(self.textInput.value);
        }, thresholdMillis);

    });

    this.clearButton.addEventListener('click', function (evt) {
        self.clear();
        self.focus();
    });

    this.clear = function () {
        this.textInput.value = '';
        onTextChange(self.textInput.value);
    };

    this.focus = function () {
        this.textInput.focus();
    };

    this.toggleClearButton = function (show) {
        if (show) {
            this.clearButton.className = 'clear-search';
        } else {
            this.clearButton.className = 'clear-search hidden';
        }
    }
}